import {
  ReportPersonOption,
  ReportSubjectOption,
} from '../Interfaces/report-filter-options.interface';
import { ReportPickerOption } from '../Interfaces/report-picker-option.interface';

export function toPersonPickerOptions(
  people: ReadonlyArray<ReportPersonOption>,
): ReportPickerOption[] {
  return people.map((person) => {
    const name = person.display_name.trim();
    return {
      id: person.id,
      label: name || person.email,
      detail: name ? person.email : null,
      deleted: false,
    };
  });
}

export function toSubjectPickerOptions(
  subjects: ReadonlyArray<ReportSubjectOption>,
): ReportPickerOption[] {
  return subjects.map((subject) => ({
    id: subject.id,
    label: subject.name,
    detail: null,
    deleted: subject.deleted,
  }));
}
